import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChatDetailComponent } from './detail/chat-detail.component';
import { ChatListComponent } from './list/chat-list.component';

const routes: Routes = [
    {
        path: 'chat',
        children: [
            { path: '{code}', component: ChatDetailComponent }
        ]
    }, {
        path: 'chats',
        children: [
            { path: '', component: ChatListComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ChatRoutingModule { }
